import { Link } from "react-router-dom";
import type { ContentTopic } from "@/types/content";

const heroStats = [
  { label: "覆盖话题", value: "1,200+" },
  { label: "观点交锋", value: "38万+" },
  { label: "内容分类", value: "7 个" },
];

export default function Hero({ hotTopics }: { hotTopics: ContentTopic[] }) {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20watermelon%20field%20illustration%20with%20bold%20coral%20red%20and%20fresh%20green%20geometric%20shapes%2C%20dark%20shadowy%20depth%20with%20deep%20contrast%20for%20text%20readability%2C%20editorial%20poster%20art%20style%2C%20soft%20grain%20texture%2C%20no%20text%2C%20modern%20playful%20composition&width=1800&height=1100&seq=gty-hero-01&orientation=landscape"
        alt="瓜田吃瓜热门话题与讨论区主题插画背景"
        title="瓜田吃瓜 - 热门话题与观点交锋"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70" />

      <div className="relative w-full px-4 md:px-8 pt-16 md:pt-24 pb-0">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/15 border border-white/25 text-xs text-white/90 backdrop-blur-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse" />
            站内热榜 · 每小时更新
          </span>

          <h1 className="mt-6 font-display text-4xl md:text-6xl lg:text-7xl text-white leading-tight">
            瓜田吃瓜
            <span className="block mt-3 text-base md:text-2xl font-normal tracking-wide text-white/90" style={{ fontFamily: "var(--font-heading)" }}>
              热门话题、讨论区与观点交锋，一次吃透
            </span>
          </h1>

          <p className="mt-6 mx-auto max-w-2xl text-sm md:text-base leading-relaxed text-white/80">
            从综艺名场面到剧集大结局，从演唱会应援到短剧行业观察，我们把事件脉络、不同立场和最新回转整理在一起，让你不必在碎片信息里来回拼图。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/topics"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
            >
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
              逛今日话题榜
            </Link>
            <Link
              to="/discussion"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white/10 border border-white/35 text-white text-sm whitespace-nowrap hover:bg-white/20 transition-colors duration-200"
            >
              <i className="ri-chat-smile-3-line w-4 h-4 flex items-center justify-center" />
              进讨论区围观
            </Link>
          </div>

          <div className="mt-10 md:mt-12 grid grid-cols-3 gap-4 max-w-xl mx-auto">
            {heroStats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-3xl font-bold text-white">{stat.value}</div>
                <div className="mt-1 text-xs text-white/70">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative mt-12 md:mt-16 border-t border-white/15 bg-black/35 backdrop-blur-sm py-3 overflow-hidden">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {[...hotTopics, ...hotTopics].map((topic, index) => (
            <Link
              key={`${topic.id}-${index}`}
              to={`/topic/${topic.id}`}
              className="flex items-center gap-2 px-5 text-sm text-white/80 hover:text-white whitespace-nowrap transition-colors"
            >
              <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-500 text-background-50">
                #{(index % hotTopics.length) + 1}
              </span>
              {topic.title}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}